import React from "react";
import styled from "styled-components";
import { assetsBaseUrl } from "../../../core/config";
import pageDataAu from "../page-data-au.json";
import pageDataNz from "../page-data-nz.json";
import { Text, Flex } from "basis";
import ReactHTMLParser from "react-html-parser";
import { BREAKPOINT } from "../../../components/theme";

const StyledCardArt = styled.div`
  display: none;
  flex-wrap: wrap;
  justify-content: start;
  p {
    margin: 15px 0 30px;
  }
  @media (min-width: ${BREAKPOINT.SIZE_MOBILE}) {
    display: flex;
    justify-content: center;
    > div {
      width: 100%;
    }
  }
`;

const StyledCardArtImg = styled.img`
  height: ${({ isVertical }) => (isVertical ? "100px" : "35px")};
  margin-right: 5px;
  display: block;
`;

const CardArt = ({ au = false, nz = false, page, order }) => {
  let logos;
  if (au) {
    // If checkoutTemplate exists (any value), show GO Mastercard first, then Gem Visa
    logos = order?.checkoutTemplate 
      ? ["GOPMC_V1.png", "GEMVISA_V1.png"]
      : ["GEMVISA_V1.png", "GOPMC_V1.png"];
  } else {
    logos = ["GemVisaNZ_Vertical.png"];
  }

  const pageData = au ? pageDataAu : pageDataNz;
  let url
  if(au){
    url =`${assetsBaseUrl}/latitude/acceptedCard`
  }else{
    url = `${assetsBaseUrl}/latitude/acceptedCard/checkout`
  }

  return (
    <StyledCardArt>
      <Flex placeItems="center" margin="8 0 0 0">
        {logos.map((logo) => (
          <StyledCardArtImg
            isVertical
            key={logo}
            src={`${url}/${logo}`}
          />
        ))}
      </Flex>
      {nz && <Text align="center">{ReactHTMLParser(pageData.cardsText)}</Text>}
    </StyledCardArt>
  );
};

export default CardArt;